import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import "./assets/page-not-found.css";

const PageNotFound = () => {
    return (
        <div className="not-found-wrapper">
            <div className="not-found-content">
                <div className="icon-pulse">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <h1>404</h1>
                <h3>Oops! Halaman Tidak Ditemukan</h3>
                <p className="text-muted">
                    Maaf, halaman yang Anda cari tidak ada atau telah dipindahkan.
                </p>
                <Link to="/" className="btn-back-home">
                    <FontAwesomeIcon icon={faHome} className="mr-2" />
                    Kembali ke Beranda
                </Link>
            </div>
        </div>
    );
};

export default PageNotFound;